<!--
 * @Author: Pythonista Wong
 * @Date: 2020-08-13 21:39:53
 * @LastEditTime: 2022-12-09 13:44:58
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/card-detail/index.vue
-->
<style scoped lang="sass">
.bottom
  display: flex

  .date
    flex: 1
    margin-right: 20px

  .ccv
    flex: 1

.input
  margin-bottom: 52px

.card_detail
  background: #fff

  .overflow_scroll
    padding: 16px 16px 0 16px

    // .card-wrapper
    //   margin-bottom: 20px

    .form
      .name
        display: flex
        margin-bottom: 10px

        .first_name
          margin-right: 20px

      .card_number
        margin-bottom: 10px

      .card_expiry
        position: relative
        display: flex
        justify-content: space-between

        .card_title
          position: absolute
          top: 0
          left: 0
          height: 12px
          line-height: 12px
          font-size: 12px
          color: rgba(51, 68, 85, 0.45) !important

.expiry
  width: 35%

  ::v-deep
    .label
      width: 155px !important

.cvv
  width: 50%
</style>

<style lang="sass" scoped>
::v-deep
  .jp-card-expiry
    height: 30px
    font-size: 20px

  .jp-card-expiry:before
    margin-bottom: 5px !important

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  input
    color: var(--menu-primary-text-colour) !important

.padding
  padding-bottom: 58px !important

.margin
  margin-bottom: 20px

.footer_common
  position: fixed
  bottom: 0

// .card-wrapper
//   position: relative

// .expire_container
//   z-index: 2
//   position: absolute
//   bottom: 28px
//   right: 44px

//   .expire_box
//     position: relative
//     color: #fff
//     height: 0.83333rem
//     font-size: 0.55556rem

//     &::before
//       font-family: "Helvetica Neue", Helvetica, Arial, sans-serif
//       font-weight: bold
//       font-size: 0.19444rem
//       white-space: pre
//       display: block
//       opacity: .5
//       content: 'MONTH / YEAR'
//       font-size: 0.19444rem
//       text-transform: uppercase

.blank
  text-align: center
  font-size: bold
  font-family: "Bitstream Vera Sans Mono", Consolas, Courier, monospace

.ios_expiry
  flex: 1
  margin-right: 20px

::v-deep
  .van-popup
    width: 70%
    padding: 20px
    font-size: 20px

  .threeDS-popup
    display: flex
    align-items: center
    justify-content: space-between
    width: 100%
    height: 58px
    line-height: 58px
    background: var(--menu-header-background-colour)
    color: var(--menu-header-colour)

  .arrow_left
    height: 45px
    width: 45px

</style>

<template lang="pug">
  .card_detail
    .overflow_scroll.padding.margin
      PayCard(
        :number="valueFields.cardNumber"
        :holder="cardUserName"
        :exp="valueFields.cardExpiry"
        :cvc="valueFields.cardCvv"
        :is-typing-cvc="!showExpireDate"
      )
      py-form.form(ref="form" :model="valueFields" :rules="ruleValidate")
        .name
          py-form-item.first_name(prop='cardFirstName')
            py-input(v-model="valueFields.cardFirstName" :title="t('first_name', 'First Name')" type="text")
          py-form-item.last_name(prop='cardLastName')
            py-input(v-model="valueFields.cardLastName" :title="t('last_name', 'Last Name')" type="text")
        .card_number
          py-form-item(prop='cardNumber')
            py-input(
              :value="valueFields.cardNumber"
              :title="t('card_number', 'Card number')"
              type="number"
              @input="setCardNumber"
            )
        .card_expiry
          py-form-item.expiry(
            prop='cardExpiry'
            :class="{'ios_expiry': true}"
          )
            expire-date-input(
              v-if="!isIOS || 1 < 2"
              v-model="valueFields.cardExpiry"
            )
            py-input(
              v-else
              :value="valueFields.cardExpiry"
              :title="t('expiry_mm_yy', 'Expiry (MM / YY)')"
              maxlength="7"
              type="number"
              @input="setExpiry"
            )
          py-form-item.cvv(prop='cardCvv')
            py-input(
              id="cvv"
              name="cvc"
              v-model="valueFields.cardCvv"
              :title="t('cvv', 'CVV')"
              type="number"
              maxlength="4"
              @focus="handleFocus"
              @pyBlur="handleBlur"
            )
    footer-common.footer_common(:text="submitPaymentButtonText" @clickButton="handleSubmit")

    van-popup(v-model="showErrorPopUp" @closed="errorClose") {{ errorMsg }}

    mu-dialog( transition="fade" fullscreen :open.sync="show3dsIframe" v-loading="iframeLoading" )
      mu-appbar(color="primary" class="threeDS-popup" :title="t('verification_process', 'Verification Process')" )
        img.arrow_left(slot="left"
          src="@/assets/navPic/arrow_left.png"
          @click="show3dsIframe = false"
        )
      friendly-iframe(frame-id="threeDS_iframe" name="3ds iframe" :src="iframeUrl" @load="iframeLoading = false" @finish="finishIframeChecking")

    tab-manage-popup-dialog(
      v-model="showPayErrorDialog"
      :title="showPayErrorDialogSettings.title"
      :content="showPayErrorDialogSettings.content"
      :first-button-text="showPayErrorDialogSettings.firstButtonText"
      :second-button-text="showPayErrorDialogSettings.secondButtonText"
      isFlexColumn
      showIcon
      @clickHandlerFirstButton="handleSubmit"
    )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import AmountPay from '@/components/AmountPay'
import SmallIcon from '@/components/SmallIcon'
import PayCard from '@/components/PayCard'
import {
  addOrder,
  getOrder,
  getSafe2payOauthToken,
  getUser,
  getVenue,
  getWindcaveSession,
  payOrder,
  payVenueSubGroupOrder
} from 'api/product'
import { updateTab } from 'api/tab'
import ExpireDateInput from 'components/ExpireDateInput'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { isIOS } from '@/utils/navigator'
import { delineryAddress } from 'utils/message'
import resizeHandler from 'utils/resizeHandler'
import axios from 'axios'
import { t } from '@/utils/language'
import { orderAmountNow } from '@/utils/surchargeSnapshot'
import { deliveryFeeFor } from '@/utils/deliveryFee'
import { withOrderMenu } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { withMenuAddress } from '@/utils/menu/menuAddress'
import { stopOrderingForPreview } from '@/utils/menu/previewOrderBlock'

function _formatCardNum(number) {
  if (!number) return ''
  const a = number.slice(0, 4)
  const b = number.slice(4, 8)
  const c = number.slice(8, 12)
  const d = number.slice(12, 16)
  return `${a} ${b} ${c} ${d}`
}

@Component({
  requiredComponents: ['muse-ui', 'global-popup'],

  props: {
    venueSubGroupId: {
      type: String
    }
  },

  created() {
    this.$store.commit('showLoading')
  },

  async mounted() {
    // 多版本菜单 B6（U-B6-2 review 第 2 轮 G11，纵深）：菜单预览页不能付款 —— 一进卡页就停、什么都不加载（不读用户、不挂 FatZebra、不查订单）。
    // Windcave AJAX 模式下卡号是用全局 axios 直接交给 Windcave 的，请求层的预览本地拦管不到；created 开了加载圈，这里关掉
    if (stopOrderingForPreview(this.$route)) {
      this.$store.commit('closeLoading')
      return
    }
    this.getQuery()
    this.userId = localStorage.getItem('userId') || ''
    this.notificationKey = localStorage.getItem('notificationKey') || ''
    if (this.userId || this.notificationKey) {
      this.phoneTitle = this.phoneTitleConfrim
      this.emailTitle = this.emailTitleConfrim
      await this._getUserInfo()
    } else {
      this.$store.commit('closeLoading')
    }
    this.addListen()

    if (this.useWindcaveAjaxPost) {
      // await this.initWindcaveAjax()
    } else {
      window.addEventListener('fz.sca.success', this.handleFatZebraEvent)
      window.addEventListener('fz.validation.error', this.handleFatZebraEvent)
      // Handle errors related to SCA
      window.addEventListener('fz.sca.error', this.handleFatZebraEvent)
      this.initFatZebra()
    }

    // check show error message or not
    if (this.$route.query.error === 'declinePay' || this.$route.query.error === 'cancelPay') {
      this.showPayErrorDialog = true
    }
    await this.checkOrderStatus()
  },

  destroyed() {
    if (this.fatzebra !== null) {
      delete this.fatzebra
    }
    window.removeEventListener('fz.sca.success', this.handleFatZebraEvent)
    window.removeEventListener('fz.validation.error', this.handleFatZebraEvent)
    window.removeEventListener('fz.sca.error', this.handleFatZebraEvent)
  },

  mixins: [resizeHandler],

  components: {
    AmountPay,
    SmallIcon,
    ExpireDateInput,
    PayCard
  },

  computed: {
    ...mapState(['isFromStartTabToCardDetails']),
    ...mapState({
      isOnline: state => state.app.isOnline,
      deliveryInfo: state => state.contactDetails?.deliveryInfo[state.venueId] ?? {},
      deliverySetting: state => state.venueHome.deliverySetting,
      routerInfo: state => state.venueHome.routerInfo
    }),

    tabInfo() {
      return this.$store.getters.tabInfo(this.venueId)
    },

    venueId() {
      return this.$store.state.venueId
    },

    // Credit card user name splicing
    // 拼接信用卡的用户名称
    cardUserName() {
      return this.valueFields.cardFirstName + ' ' + this.valueFields.cardLastName
    },

    isFromTabPay() {
      return this.isTabPay || this.isFromStartTabToCardDetails
    },

    submitPaymentButtonText() {
      return this.isFromTabPay ? t('next', 'NEXT') : t('submit_payment', 'SUBMIT PAYMENT')
    },

    addItemlist() {
      const itemList = this.$store.getters.itemList(this.venueId).map(item => {
        if (item.comboProducts) {
          return {
            ...item,
            // ComboProducts needs to remove the modifications
            // 去掉 comboProducts 的配菜
            comboProducts: this.deleteDuplicate(item.comboProducts.filter(e => e.type !== 'optional'), item.addList.filter(item => item.type !== 'oneProduct' && item.type !== 'optional'), item.removeList),
            addList: item.addList.filter(item => item.type !== 'oneProduct'),
          }
        } else {
          return item
        }
      })
      return itemList
    },

    isSubgroupPayment() {
      return this.$route.name.includes('venue-sub-group') && this.venueSubGroupId
    }
  }
})

class CardDetail extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  isTabPay = false
  showExpireDate = true
  errorMsg = ''
  showErrorPopUp = false
  token = ''
  isIOS = isIOS()
  useWindcaveAjaxPost = false
  show3dsIframe = false // common 3ds iframe
  iframeUrl = 'about:blank'
  iframeLoading = false
  windcaveConfig = {
    id: '',
    links: [],
    testMode: true,
    ajax: {},
    ajax3ds: {}
  }

  fatZebra = null
  enable3DS = false
  card3dsCheckResult = null
  refreshPage = false
  notificationKey = ''
  userId = ''
  orderNo = ''
  orderId = ''
  createOrderId = ''
  createOrderNo = ''
  oldFields = {
    cardFirstName: '',
    cardLastName: '',
    cardNumber: '',
    cardCvv: '',
    cardExpiry: ''
  }

  valueFields = {
    cardFirstName: '',
    cardLastName: '',
    cardNumber: '',
    cardCvv: '',
    cardExpiry: ''
  }

  formValidate = {
    name: '',
    mail: ''
  }

  ruleValidate = {
    cardNumber: [
      {
        required: true,
        message: t('card_number_required', 'Card number is required'),
        trigger: 'blur'
      },
      {
        validator: this._validateCardNum,
        trigger: 'blur'
      },
    ],
    cardFirstName: [
      {
        required: true,
        message: t('first_name_required', 'First name is required'),
        trigger: 'blur'
      },
    ],
    cardLastName: [
      {
        required: true,
        message: t('last_name_required', 'Last name is required'),
        trigger: 'blur'
      },
    ],
    cardExpiry: [
      {
        required: true,
        message: t('expiry_required', 'Expiry is required'),
        trigger: 'blur'
      },
      {
        validator: this._validateDate,
        trigger: 'blur'
      },
    ],
    cardCvv: [
      {
        required: true,
        message: t('cvv_required', 'CVV is required'),
        trigger: 'blur'
      },
      {
        validator: this._validateCvv,
        trigger: 'blur'
      },
    ],
  }

  name = t('name_on_card', 'Name on card')
  card = t('card_number', 'Card number')
  date = t('expiry_date', 'Expiry date')
  ccv = 'CCV'
  totalPrice = 0
  creditCardYearValidateFirstTime = false
  showPayErrorDialog = false
  showPayErrorDialogSettings = {
    title: t('payment_failed', 'Payment failed'),
    content: t('payment_problem_retry', 'We had a problem processing your payment. Would you like to retry?'),
    firstButtonText: t('retry', 'Retry'),
    secondButtonText: t('cancel', 'Cancel'),
  }

  handleFocus(event) {
    this.showExpireDate = false
  }

  handleBlur(event) {
    // animate time 300ms
    setTimeout(() => {
      this.showExpireDate = true
    }, 300)
  }

  handleFatZebraEvent(event) {
    // Obtain 3DS2 results which will be used to make a purchase in the backend
    console.log(event)
    if (event.type === 'fz.sca.success') {
      // this.displayError('success', true)
      this.card3dsCheckResult = event.detail
      this.handleSubmit(true)
    } else {
      this.refreshPage = true
      this.displayError(t('card_validation_failed', 'Card Validation Failed, Please Try Another One'), true, true)
    }
  }

  async initFatZebra() {
    this.fatZebra = null
    delete this.fatZebra
    const orderId = this.orderId || this.createOrderId
    const tokenResult = await getSafe2payOauthToken({
      id: orderId,
      venueId: this.venueId
    }, orderId)
    if (tokenResult && tokenResult.token && tokenResult.enable) {
      this.enable3DS = true
      localStorage.setItem('fz-access-token', tokenResult.token)
      console.log(tokenResult.token)
      const username = process.env.VUE_APP_ENV === 'production' ? 's2p-mondoconnex' : 'dq-mondo'
      this.fatZebra = new window.FatZebra({
        username: username
      })
    }
  }

  async initWindcaveAjax() {
    const orderId = this.orderId || this.createOrderId
    const params = {
      id: orderId,
      venueId: this.venueId,
      cardId: this.token
    }
    if (this.oldFields.cardNumber !== this.valueFields.cardNumber) {
      delete params.cardId
    }

    const tempResult = await getWindcaveSession(params, orderId)
    if (tempResult && tempResult.windcaveConfig) {
      this.windcaveConfig.id = tempResult.windcaveConfig.id
      this.windcaveConfig.links = tempResult.windcaveConfig.links
      this.windcaveConfig.testMode = tempResult.windcaveConfig.testMode
      this.windcaveConfig.ajax = tempResult.windcaveConfig.ajax ?? {}
      this.windcaveConfig.ajax3ds = tempResult.windcaveConfig.ajax3ds ?? {}
    }
  }

  async ajaxPostWindcave() {
    if (this.useWindcaveAjaxPost && this.windcaveConfig.ajax.href) {
      const cardInfo = this.$store.state.paymentInfo.creditCard
      let postData = {}
      if (this.token && this.oldFields.cardNumber === this.valueFields.cardNumber) {
        postData = {
          card: {
            cardHolderName: cardInfo.name,
            cardId: this.token,
            dateExpiryMonth: cardInfo.expireMonth,
            dateExpiryYear: cardInfo.expireYear,
            cvc2: cardInfo.cvc
          }
        }
      } else {
        postData = {
          card: {
            cardHolderName: cardInfo.name,
            cardNumber: cardInfo.cardNumber.replace(' ', ''),
            dateExpiryMonth: cardInfo.expireMonth,
            dateExpiryYear: cardInfo.expireYear,
            cvc2: cardInfo.cvc
          }
        }
      }
      try {
        const postResult = await axios.post(this.windcaveConfig.ajax.href, postData)
        // console.log(postResult)
        if (postResult.data?.links && postResult.data.links[0].rel === '3DSecure') {
          window.location.href = postResult.data.links[0].href
          return 'redirect'
        }
        return postResult.data ?? {}
      } catch (error) {
        return false
      }
    }
    return false
  }

  async card3dsCheck() {
    const orderId = this.orderId || this.createOrderId
    const orderNo = this.orderNo || this.createOrderNo
    // await this.initFatZebra()
    const tokenResult = await getSafe2payOauthToken({
      id: orderId,
      venueId: this.venueId,
      venueSubGroupId: this.venueSubGroupId ?? '',
      hashMac: true
    }, orderId)
    console.log(tokenResult)
    this.card3dsCheckResult = null

    if (tokenResult && tokenResult.token && tokenResult.venue) {
      if (this.fatZebra) {
        const paymentMethod = {
          type: 'card',
          data: {}
        }
        if (this.valueFields.cardNumber === this.oldFields.cardNumber) {
          if (this.token && this.valueFields.cardNumber === this.oldFields.cardNumber) {
            paymentMethod.type = 'card_on_file'
            paymentMethod.data.token = this.token
          }
        }
        if (paymentMethod.type === 'card') {
          paymentMethod.data = {
            number: this.valueFields.cardNumber.replaceAll(' ', ''),
            holder: this.valueFields.cardFirstName + ' ' + this.valueFields.cardLastName,
            expiryMonth: this.valueFields.cardExpiry.split('/')[0].trim(),
            expiryYear: '20' + this.valueFields.cardExpiry.split('/')[1].trim(),
            cvv: this.valueFields.cardCvv
          }
        }
        const postData = {
          customer: {
            firstName: this.$store.state.contactDetails?.user?.name.split(' ').slice(0, -1).join(' '),
            lastName: this.$store.state.contactDetails?.user?.name.split(' ').slice(-1).join(' '),
            email: this.$store.state.contactDetails?.user?.email ?? '',
            address: tokenResult.venue.address,
            city: tokenResult.venue.suburb,
            postcode: tokenResult.venue.postcode,
            state: tokenResult.venue.state,
            country: tokenResult.venue.country
          },
          paymentIntent: {
            payment: {
              amount: tokenResult.amount ? parseInt(tokenResult.amount) : this.$store.getters.realPrice(this.venueId) * 100,
              currency: this.$store.state.currency.toUpperCase(),
              reference: orderNo,
            },
            verification: tokenResult.token // made up value
          },
          paymentMethod: paymentMethod
        }
        console.log(postData)

        this.fatZebra.verifyCard(postData)
      } else {
        // this.fatZebra = null // do not use 3ds check anymore
        this.handleSubmit(true)
      }
    }
  }

  /**
   * 给 CardNumber 赋值
   * @param val {String} CardNumber 输入框的值
   * 1. 字符串转数组
   * 2. 遍历每个字符串，先把所有的非数字过滤掉
   * 3. 再每隔 4 个字符，插入一个空格
   */
  setCardNumber(val) {
    // Clear non numeric
    // 清除非数字
    val = val.replace(/[^\d]/g, '')
    if ((val === this.oldFields.cardNumber) && val.replace(/\s+/g, '').length >= 14) return
    let strArr = []
    for (let index = 0; index < val.length; index++) {
      strArr.push(val[index])
    }

    // Each time the input box changes, filter non numbers first
    // 每次输入框的内容发生改变时，先过滤非数字
    strArr = strArr.filter(str => /^[0-9]+$/.test(str))

    // Insert a space every four
    // 每隔 4 个字符，插入一个空格
    if (strArr.length >= 5) {
      strArr.splice(4, 0, ' ')
    }

    if (strArr.length >= 10) {
      strArr.splice(9, 0, ' ')
    }

    if (strArr.length >= 15) {
      strArr.splice(14, 0, ' ')
    }

    this.valueFields.cardNumber = strArr.join('')
  }

  setExpiry(val) {
    // Clear non numeric
    // 清除非数字
    val = val.replace(/[^\d]/g, '')
    let strArr = []
    for (let index = 0; index < val.length; index++) {
      strArr.push(val[index])
    }
    // Each time the input box changes, filter non numbers first
    // 每次输入框内容发送改变时，先过滤非数字
    strArr = strArr.filter(str => /^[0-9]+$/.test(str))

    if (strArr.length >= 2) {
      strArr.splice(2, 0, ' / ')
    }
    this.valueFields.cardExpiry = strArr.join('')
  }

  addListen() {
    this._creditCardInputControl()
    this._cvvInputControl()
    if (!this.isIOS && this.isMobile) {
      // Android
      // 安卓
      const inputsList = [...document.getElementsByTagName('input')]
      for (const eachDom of inputsList) {
        _scrollToBottom(eachDom)
      }
    }

    function _scrollToBottom(dom) {
      dom.addEventListener('focus', function () {
        // Top: 3000 means infinity
        // top: 3000 的意思是无穷大
        window.scrollTo({
          top: 3000,
          left: 100,
          behavior: 'smooth'
        })
      })
    }
  }

  _creditCardInputControl() {
    // Set cursor position
    // 设置光标的位置
    function setCaretPosition(textDom, pos) {
      if (textDom.setSelectionRange) {
        // IE Support
        textDom.focus()
        textDom.setSelectionRange(pos, pos)
      } else if (textDom.createTextRange) {
        // Firefox support
        var range = textDom.createTextRange()
        range.collapse(true)
        range.moveEnd('character', pos)
        range.moveStart('character', pos)
        range.select()
      }
    }

    const creditCardDom = document.getElementsByTagName('input')[2]
    creditCardDom.addEventListener('input', function (e) {
      setCaretPosition(creditCardDom, 100)
    })
  }

  // Receive 3 arrays and remove objects containing brr and crr from arr
  // 接收 3 个数组，去掉 arr 中包含 brr 和 crr 的对象
  deleteDuplicate(arr, brr, crr) {
    const c = []
    const y = []
    arr.forEach((item) => {
      const check = brr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        c.push(item)
      }
    })
    c.forEach((item) => {
      const check = crr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        y.push(item)
      }
    })
    return y
  }

  _cvvInputControl() {
    // Set cursor position
    // 设置光标位置
    function setCaretPosition(textDom, pos) {
      if (textDom.setSelectionRange) {
        // IE Support
        textDom.focus()
        textDom.setSelectionRange(pos, pos)
      } else if (textDom.createTextRange) {
        // Firefox support
        var range = textDom.createTextRange()
        range.collapse(true)
        range.moveEnd('character', pos)
        range.moveStart('character', pos)
        range.select()
      }
    }

    const cvvDom = document.getElementsByTagName('input')[4]
    cvvDom.addEventListener('input', function (e) {
      setCaretPosition(cvvDom, 100)
    })
  }

  async _getUserInfo() {
    const res = await getUser({
      id: this.userId,
      notificationKey: this.notificationKey,
      orderId: this.orderId,
      venueSubGroupId: this.venueSubGroupId,
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.valueFields = {
      cardFirstName: res.payment?.creditCard?.name?.split(' ')[0] || '',
      cardLastName: res.payment?.creditCard?.name?.split(' ')[1] || '',
      cardNumber: _formatCardNum(res.payment.creditCard.card),
      cardExpiry: res.payment.creditCard.expireDate ? (res.payment.creditCard.expireDate.split('/')[0] + ' / ' + res.payment.creditCard.expireDate.split('/')[1]) : '',
      cardCvv: ''
    }
    this.oldFields = { ...this.valueFields }
    this.token = this._getToken(res.payment)
    this.$store.commit('closeLoading')
  }

  _getToken(paymentInfo) {
    if (paymentInfo && paymentInfo.token) {
      return paymentInfo.token
    } else {
      return ''
    }
  }

  _validateDate(rule, value, callback) {
    if (this.isIOS) {
      if (value.length < 7) {
        return callback(new Error(t('expiry_format_incorrect', 'Format of expiry is incorrect')))
      }
    }
    const [getMonth, getYear] = value.split('/')
    const month = getMonth.trim()
    const year = getYear.trim()

    // Failure conditions
    // 失败的条件
    // console.log(this.creditCardYearValidateFirstTime)
    if (!month) return callback(new Error(t('expiry_month_required', 'Expiry month is required')))
    if (!year && !this.creditCardYearValidateFirstTime) return callback(new Error(t('expiry_year_required', 'Expiry year is required')))
    this.creditCardYearValidateFirstTime = false

    if (parseInt(month) === 0 || parseInt(month) > 12) {
      return callback(new Error(t('invalid_month', 'Invalid Month')))
    }
    if (parseInt(year) === 0) {
      return callback(new Error(t('invalid_year', 'Invalid Year')))
    }
    return callback()
  }

  _validateCvv(rule, value, callback) {
    if (value.length < 3) {
      callback(new Error(t('cvv_not_correct', 'CVV is not correct')))
    }
    callback()
  }

  _validateCardNum(rule, value, callback) {
    const cardNum = value.replace(/\s+/g, '')
    if (value.length === 19) {
      callback()
    } else if (value.length === 16 && !value.trim().includes(' ')) {
      callback()
    } else if (cardNum.length === 15) {
      callback()
    } else {
      callback(new Error(t('incorrect_card_number', 'Incorrect card number. Please re-enter')))
    }
  }

  getQuery() {
    this.orderId = this.$route.query.orderId
    this.orderNo = this.$route.query.orderNo
    this.createOrderId = this.$route.query.createOrderId
    this.createOrderNo = this.$route.query.createOrderNo
    this.isTabPay = this.$route.query.isTabPay
    this.useWindcaveAjaxPost = this.$route.query.useWindcaveAjaxPost === 'true' ?? false
  }

  // Core payment
  // 核心的支付
  handleSubmit(skipFatzebra) {
    // 多版本菜单 B6（U-B6-2 review 第 2 轮 G11）：菜单预览页 ⇒ 弹那句，不校验、不取会话、不提交卡号（与 mounted 那一道同一个判断）
    if (stopOrderingForPreview(this.$route)) return
    this.$refs.form.validate(async (valid) => {
      if (valid) {
        // If it is delivery, judge whether there are expired products
        // 如果是 delivery，判断是否有过期商品
        let isExpire
        if (this.isOnline) isExpire = await this._isExpire()
        if (this.isOnline && !isExpire) return

        this.$store.commit('showLoading')
        if (this.useWindcaveAjaxPost) {
          this.saveCreditCardInfo()
          await this.initWindcaveAjax()
          // ajax post first
          this.windcaveConfig.result = await this.ajaxPostWindcave()
          if (this.windcaveConfig.result === 'redirect') return
        } else {
          if (this.enable3DS === true && skipFatzebra !== true && this.isTabPay !== true) {
            this.card3dsCheck()
            return // return due to it need to wait event handle
          }
          this.saveCreditCardInfo()
        }

        // 后付款
        if (this.orderNo && this.orderId) {
          try {
            const response = await this.pay(this.orderId)
            if (this.require3dsVerification(response)) {
              return // require 3ds verification
            }
            this.clearProductListAndUnpaidOrder()
            await this._hasOrderIdDecideToJump()
          } catch (error) {
            this.displayError(error)
          }
        } else if (this.createOrderId && this.createOrderNo) {
          // Pay first
          // 先付款
          await this.jumpToMyOrder(this.createOrderId)
        } else {
          // create tab
          // From the menu, no order is generated. It's time to pay with a bank card
          // 从 menu 进来，没有产生 order 时，还想用银行卡支付
          await this._createTab()
        }
        // Clear table number
        // 清空桌号
        this.$store.commit('saveTable', '')
      } else {
        this.$store.commit('closeLoading')
        console.log('表单校验失败')
      }
    })
  }

  // check order status
  async checkOrderStatus() {
    let orderId = null
    if (this.orderNo && this.orderId) {
      orderId = this.orderId
    } else if (this.createOrderId && this.createOrderNo) {
      orderId = this.createOrderId
    }
    if (orderId) {
      const res = await getOrder({
        id: orderId,
        venueSubGroupId: this.venueSubGroupId ?? null,
      }).catch(error => {
        console.log(error)
      })
      if (res.status === 1) {
        this.clearProductListAndUnpaidOrder()
        await this._hasOrderIdDecideToJump()
        this.iframeUrl = 'about:blank'
        this.show3dsIframe = false
        this.iframeLoading = false
      }
    }
  }

  async finishIframeChecking(event) {
    console.log(event)
    this.iframeUrl = 'about:blank'
    this.show3dsIframe = false
    this.iframeLoading = false
    if (event.finishVerification) {
      if (this.orderNo && this.orderId) {
        if (event.orderId === this.orderId) {
          // finish the payment
          this.clearProductListAndUnpaidOrder()
          await this._hasOrderIdDecideToJump()
        }
      } else if (this.createOrderId && this.createOrderNo) {
        // Pay first
        // 先付款
        if (event.orderId === this.createOrderId) {
          this.clearProductListAndUnpaidOrder()
          await this._hasCreateOrderIdDecideToJump()
        }
      }
    } else {
      // failed verification
      this.displayIframeError(t('card_validation_failed_retry', 'Card Validation Failed, Please Try Again'))
    }
  }

  displayIframeError(message) {
    this._deliveryInfoError(message)
    this.showPayErrorDialog = true
    this.$store.commit('closeLoading')
  }

  require3dsVerification(response) {
    this.$store.commit('closeLoading')
    if (response.redirectIframe && response.redirectIframe.length > 0) {
      this.iframeUrl = response.redirectIframe
      this.show3dsIframe = true
      this.iframeLoading = true
      return true
    }
    return false
  }

  // Whether there are expired products
  // 是否有过期商品
  async _isExpire() {
    if (this.deliveryInfo.orderType === 'delivery') {
      const isPass = await this._verifyUserPostcode()
      if (!isPass) {
        const self = this
        this.$createTabMessageDialog({
          $props: delineryAddress,
          $events: {
            click() {
              self._jumpToCart()
            },
          },
        }).show()
        return
      }
    }
    const state = this.$store.state
    // 与购物车报的、总额里加的是同一个数（utils/deliveryFee.js；缺 type / 第三方没报价照后端按 0，review 第 1 轮 #6）
    const baseFee = deliveryFeeFor(this.deliverySetting, this.deliveryInfo)

    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: {
        ...state.details,
        googleDeliveryTime: this.deliveryInfo?.deliveryCost?.timeCost ?? this.deliveryInfo.googleDeliveryTime,
        orderType: this.deliveryInfo.orderType,
        preOrderTimeSettings: this.deliveryInfo.preOrderTimeSettings,
        baseFee,
        minDeliveryAmount: this.deliveryInfo.minDeliveryAmount,
      },
      type: this.deliveryInfo.type,
      user: {
        id: null,
        name: null,
        email: state.contactDetails?.user?.email ?? null,
        phone: null,
        joinMarketingConsent: null,
        address: this.deliveryInfo.rawAddress,
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.addItemlist,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    return await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route)))
  }

  // Verify whether the delivery address has changed
  // 校验外卖地址是否发生变化
  async _verifyUserPostcode() {
    let isPass = false
    const rawAddress = JSON.parse(this.deliveryInfo.rawAddress)
    const { address_components } = rawAddress
    let postcode
    address_components.forEach(address => {
      if (address.types && address.types.includes('postal_code')) postcode = address.short_name
    })
    if (postcode) {
      const venueInfo = await getVenue({
        id: this.venueId
      })
      let postcodes = venueInfo?.settings?.deliverySettings?.areaSettings?.postcodes ?? []
      if (postcodes?.length) {
        postcodes = postcodes.map(item => ({
          ...item,
          zone: item?.name ?? item.zone,
          postcode: item?.postalcode ?? item.postcode
        }))
      }
      isPass = !!postcodes.find(item => item.postcode === postcode)
    }
    return isPass
  }

  async _createTab() {
    const {
      id,
      ...userInfo
    } = this.$store.state.contactDetails.user
    const data = {
      venueId: this.venueId,
      action: 'create',
      detail: {
        ...userInfo,
        paymentDetail: {
          ...this.$store.state.paymentInfo.creditCard,
          type: 'creditCard'
        },
        openDateTime: {
          date: dayjs.tz().format('YYYY-MM-DD'),
          time: dayjs.tz().format('HH:mm'),
        },
        minAmount: this.tabInfo.tabAmount,
        tabAmount: this.tabInfo.tabAmount,
      },
      userId: localStorage.getItem('userId'),
    }
    if (this.valueFields.cardNumber === this.oldFields.cardNumber) {
      if (this.token) data.detail.paymentDetail.token = this.token
    }

    try {
      const currentTabInfo = await updateTab(data)
      this._createTabSuccessToJumpToTabMenuPage(currentTabInfo)
    } catch (error) {
      console.error(error)
    } finally {
      this.$store.commit('closeLoading')
    }
  }

  _createTabSuccessToJumpToTabMenuPage(currentTabInfo) {
    console.log(currentTabInfo)
    this._setTabPassCode(currentTabInfo)
    this._jumpToManageTab(currentTabInfo)
  }

  _setTabPassCode(currentTabInfo) {
    const passCode = currentTabInfo.phone.slice(-4)
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', passCode)
  }

  // 多版本菜单 N35-B2 第 4 轮 / N35-B5：开着 3DS 时这几处是整页跳转，站内守卫补不到 ⇒ 用 withMenuAddress 把当前地址里的进店参数（mmEntry）
  // 与点单链接码（menuLink）顺手带上（没有就逐字节照旧；Custom Flows 页不带进店参数；合单目标不带）。回来的那一页才认得这一次光顾扫的码。
  _jumpToManageTab(currentTabInfo) {
    if (this.enable3DS) {
      window.location.href = withMenuAddress(`${window.location.origin}/v/${this.venueId}/tab-admin/${currentTabInfo.id}/menu?isTabReady=1`, this.$route)
    } else {
      this.$router.push({
        path: `/v/${this.venueId}/tab-admin/${currentTabInfo.id}/menu`,
        query: {
          isTabReady: 1
        }
      })
    }
  }

  // PPay later
  // 后付款
  async _hasOrderIdDecideToJump() {
    // The tabPay payment entered from the Start-tab page uses the bank card to pay. It is the tabPay entered from the menu page
    // 从 Start-tab 页面进入的 tabPay 支付，利用的是银行卡支付，是从 menu 页面进来的 tabPay
    if (this.isFromStartTabToCardDetails || this.$route.name === 'start-tab') {
      const tabInfo = await getUser({ id: localStorage.getItem('userId') }).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      })
      const currentVenueTabInfo = tabInfo.currentTab.find(item => item.venueId === this.venueId)
      this._createTabSuccessToJumpToTabMenuPage(currentVenueTabInfo)
    } else {
      // You enter tabPay from the payment page, and then pay with the bank card. In fact, it has an orderId
      // 是从 payment 页面进入 tabPay 的，然后用银行卡支付，他其实是存在 orderId
      if (this.isTabPay) {
        this._jumpToTabOrderReceived()
      } else {
        // Normal payment
        // 正常的支付
        this._jumpToOrder()
      }
    }
  }

  _jumpToOrder() {
    if (this.enable3DS) {
      window.location.href = withMenuAddress(this.isSubgroupPayment ? `${window.location.origin}/vgs/${this.venueSubGroupId}/my-order/${this.orderId}?orderNo=${this.orderNo}&isMarketing=1`
        : `${window.location.origin}/v/${this.venueId}/my-order/${this.orderId}?orderNo=${this.orderNo}&isMarketing=1`, this.$route)
    } else {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/my-order/${this.orderId}` : `/v/${this.venueId}/my-order/${this.orderId}`,
        query: {
          orderNo: this.orderNo,
          isMarketing: 1
        }
      })
    }
  }

  _jumpToCart() {
    const number = this.$store.state.venueHome.routerInfo.number || this.$route.query?.tableNumber
    if (number) {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/cart/t/${number}` : `/v/${this.venueId}/cart/t/${number}`
      })
    } else {
      this.$router.push({
        path: this.isSubgroupPayment ? `/vgs/${this.venueSubGroupId}/cart/p` : `/v/${this.venueId}/cart/p`
      })
    }
  }

  /**
   * @author Pythonista Wang
   * @@overview Compare whether the checked fields of objects in the options array of two Arrays are all the same
   * @param { Array } modification1
   * @param { Array } modification2
   * @return { Boolean }
   * @copyright everyone
   */
  /**
   * @author Pythonista Wang
   * @overview 比较两个 Array 中的 options 数组中的对象的 checked 字段是否全都相同
   * @param { Array } modification1
   * @param { Array } modification2
   * @return { Boolean }
   * @copyright everyone
   */
  checkToArrayIsEqual(modification1, modification2) {
    const res = []
    modification1.forEach((item, index) => {
      item.options.forEach((each, i) => {
        const res1 = modification2[index].options[i].adjustPrice
        const res2 = each.adjustPrice
        res.push(res1 === res2)
      })
    })
    return res.every(item => item)
  }

  async pay(orderId) {
    const data = {
      id: orderId,
      venueSubGroupId: this.venueSubGroupId ?? null,
      paymentInfo: JSON.parse(JSON.stringify(this.$store.state.paymentInfo)),
    }
    data.paymentInfo.type = 'creditCard'
    delete data.paymentInfo.transactionId

    if (this.isFromStartTabToCardDetails || this.$route.name === 'start-tab') data.paymentInfo.action = 'payWithNewTab'
    // console.log(this.valueFields.cardNumber, this.oldFields.cardNumber)
    if (this.valueFields.cardNumber === this.oldFields.cardNumber) {
      if (this.token) {
        data.paymentInfo.token = this.token
      }
    } else {
      delete data.paymentInfo.token
    }
    if (this.card3dsCheckResult !== null) {
      data.paymentInfo.card3dsCheckResult = this.card3dsCheckResult
    }

    if (this.useWindcaveAjaxPost) {
      data.paymentInfo = btoa(JSON.stringify(data.paymentInfo))
      data.useWindcaveAjaxPost = true
      data.windcaveConfig = this.windcaveConfig
      data.windcaveResult = this.windcaveConfig.result ?? {}
    }

    const payOrderFun = this.isSubgroupPayment ? payVenueSubGroupOrder : payOrder

    return await payOrderFun(data).catch(error => {
      console.log(error)
      this._deliveryInfoError(error)
      this.showPayErrorDialog = true
      this.$store.commit('closeLoading')
    })
  }

  clearProductListAndUnpaidOrder() {
    if (this.isSubgroupPayment) {
      this.$store.commit('clearVenueSubGroupProductList')
    }
    this.$store.commit('clearProductList')
    this.$store.commit('clearDiscounts')
    // this.$store.commit('clearUnpaidOrder', this.venueId)
  }

  // Pay first
  // 先付款
  async jumpToMyOrder(orderId) {
    try {
      const res = await this.pay(orderId)
      if (!res) return
      if (this.require3dsVerification(res)) {
        return // require 3ds verification
      }
      this.clearProductListAndUnpaidOrder()
      await this._hasCreateOrderIdDecideToJump()
    } catch (error) {
      this.displayError(error)
    }
  }

  // Jump according to the situation, pay first
  // 分情况进行跳转，先付款
  async _hasCreateOrderIdDecideToJump() {
    if (this.isFromStartTabToCardDetails || this.$route.name === 'start-tab') {
      const tabInfo = await getUser({ id: localStorage.getItem('userId') }).catch(error => {
        console.log(error)
        this.$store.commit('closeLoading')
      })
      const currentVenueTabInfo = tabInfo.currentTab.find(item => item.venueId === this.venueId)
      this._createTabSuccessToJumpToTabMenuPage(currentVenueTabInfo)
    } else {
      if (this.isTabPay) {
        this._jumpToTabOrderReceived()
      } else if (this.isOnline) {
        this.$store.commit('addDeliveryInfo', null)
        this._jumpToPostPay()
      } else {
        this._createOrderJumpToOrder()
      }
    }
  }

  // If an error is reported in a third-party order, the showPayErrorDialogSettings error prompt is modified to the interface error message
  // 如果是第三方订单的报错，showPayErrorDialogSettings 的错误提示文案，修改为接口的报错信息
  _deliveryInfoError(error) {
    const isString = this._.isString(error)
    const deliveryInfo = this.deliveryInfo
    const isThirdPartyError = error.includes('##thirdParty##')
    if (isThirdPartyError && deliveryInfo.orderType === 'delivery' && deliveryInfo?.deliveryCost?.totalCost) {
      this.showPayErrorDialogSettings.title = t('failed', 'Failed')
      if (isString) this.showPayErrorDialogSettings.content = error.replace('##thirdParty##', '')
    }
  }

  _jumpToPostPay() {
    const urlPart = this.isSubgroupPayment ? `vgs/${this.venueSubGroupId}` : `v/${this.venueId}`
    if (this.enable3DS) {
      window.location.href = withMenuAddress(`${window.location.origin}/${urlPart}/pay/${this.createOrderId}?orderNo=${this.createOrderNo}&isMarketing=1`, this.$route)
    } else {
      this.$router.push({
        path: `/${urlPart}/pay/${this.createOrderId}`,
        query: {
          orderNo: this.createOrderNo,
          isMarketing: 1,
        }
      })
    }
  }

  _createOrderJumpToOrder() {
    const urlPart = this.isSubgroupPayment ? `vgs/${this.venueSubGroupId}` : `v/${this.venueId}`
    if (this.enable3DS) {
      window.location.href = withMenuAddress(`${window.location.origin}/${urlPart}/my-order/${this.createOrderId}?orderNo=${this.createOrderNo}&isMarketing=1`, this.$route)
    } else {
      this.$router.push({
        path: `/${urlPart}/my-order/${this.createOrderId}`,
        query: {
          orderNo: this.createOrderNo,
          isMarketing: 1,
        }
      })
    }
  }

  _jumpToTabOrderReceived() {
    const orderId = this.orderId || this.createOrderId
    const orderNo = this.orderNo || this.createOrderNo
    const urlPart = this.isSubgroupPayment ? `vgs/${this.venueSubGroupId}` : `v/${this.venueId}`
    if (this.enable3DS) {
      window.location.href = withMenuAddress(`${window.location.origin}/${urlPart}/tab-order-received/${orderId}?${orderNo}&isMarketing=1`, this.$route)
    } else {
      this.$router.push({
        path: `/${urlPart}/tab-order-received/${orderId}`,
        query: {
          orderNo,
          isMarketing: 1,
        }
      })
    }
  }

  displayError(error, showError) {
    this.errorMsg = error
    if (this.errorMsg !== 'tab_insufficient_fund') {
      // this.showErrorPopUp = true
      if (showError === true) this.showErrorPopUp = true
    }
    this.$store.commit('closeLoading')
  }

  saveCreditCardInfo() {
    const data = {
      name: this.valueFields.cardFirstName + ' ' + this.valueFields.cardLastName,
      cvc: this.valueFields.cardCvv,
      expireMonth: this.valueFields.cardExpiry.split('/')[0].trim(),
      expireYear: this.valueFields.cardExpiry.split('/')[1].trim(),
      cardNumber: _getFormatCardNum(this.valueFields.cardNumber),
    }
    this.$store.commit('saveCreditCardInfo', data)

    function _getFormatCardNum(cardNum) {
      if (cardNum.trim().includes(' ')) {
        return cardNum
      } else {
        return _formatCardNum(cardNum)
      }
    }
  }

  handleReset() {
    this.$refs.form.resetFields()
  }

  errorClose() {
    if (this.refreshPage === true) {
      window.location.reload()
    }
  }
}

export default CardDetail
</script>
